import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card, CardSection } from "cxa-components";
import HDFComponent from "./HDFComponent";
import withMatchMediaProps from "@hocs/with-match-media-props";
import UpArrow from "../../../common/ArrowUp";
import DownArrow from "../../../common/ArrowDown";

const Section = ({
  label,
  hideLabel,
  isNarrowScreen,
  columns,
  collapsible,
  components,
  ...props
}) => {
  const [showMore, setShowMore] = useState(true);

  return (
    <Card className="hdf-card">
      <CardSection>
        {!hideLabel && (
          <div className="section-header">
            <strong>{label}</strong>
          </div>
        )}

        {collapsible && (
          <div style={{ margin: "20px 40px 0 20px", display: "flex", justifyContent: "end" }}>
            <button type="button" className="link" onClick={() => setShowMore(!showMore)}>
              <span style={{ position: "relative", left: "10px" }}>
                {showMore ? (
                  <span>
                    <span style={{ marginRight: "15px" }}>Collapse</span>
                    <UpArrow width="14px" height="14px" />
                  </span>
                ) : (
                  <span>
                    <span style={{ marginRight: "15px" }}>Expand</span>{" "}
                    <DownArrow width="16px" height="16px" />
                  </span>
                )}
              </span>
            </button>
          </div>
        )}
        {showMore && (
          <div
            className="grid-container"
            style={{ gridTemplateColumns: `repeat(${isNarrowScreen ? 1 : columns}, 1fr)` }}
          >
            {components &&
              components.map(comp => {
                return <HDFComponent key={comp.id} name={comp.id} comp={comp} {...props} />;
              })}
          </div>
        )}
      </CardSection>
    </Card>
  );
};

Section.propTypes = {
  label: PropTypes.string,
  hideLabel: PropTypes.bool,
  isNarrowScreen: PropTypes.bool,
  collapsible: PropTypes.bool,
  columns: PropTypes.number,
  components: PropTypes.array,
  dependents: PropTypes.array,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(Section);



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/Section.js